import AppData from "../../../app.data";
import { Utils } from "../../../utils/utils";
import SoundService from "../../sound/sound.service";

export class EventMediaHandler {
    private appData: AppData;
    private utils: Utils;
    private playingSoundData: any = null;
    public isVideoPlaying = false;

    private soundService: SoundService;

    constructor(soundService: SoundService) {
        this.appData = new AppData();
        this.utils = new Utils();
        this.soundService = soundService;
    }

    public handleSoundClick(intersectedData: any) {

        const soundData = intersectedData.artworkWrapper.artworks[intersectedData.artworkWrapper.activeArtwork].artworkData
        soundData.slot = this.utils.getSlotObjectBySlotTarget(intersectedData.index, this.appData)
        soundData.playButton = soundData.slot.getObjectByName("button_play")
        soundData.pauseButton = soundData.slot.getObjectByName("button_pause")

        // Check if this is the same sound that's currently playing
        if (this.playingSoundData && this.playingSoundData === soundData && soundData.isPlaying) {
            // Stop the current sound (same sound clicked while playing)
            soundData.sound.stop()
            soundData.isPlaying = false
            soundData.playButton.visible = true
            soundData.pauseButton.visible = false
            this.playingSoundData = null

            // stop artwork sound, and resume background sound
            this.soundService.playBackgroundSound();
            return // Exit early, don't start playing
        }

        // Stop any other currently playing sound
        if (this.playingSoundData && this.playingSoundData !== soundData) {
            this.playingSoundData.sound.stop()
            this.playingSoundData.isPlaying = false
            this.playingSoundData.playButton.visible = true
            this.playingSoundData.pauseButton.visible = false
            this.playingSoundData = null
        }

        // pause background sound
        this.soundService.pauseBackgroundSound();

        // Start playing the clicked sound
        soundData.sound.play()
        soundData.isPlaying = true
        soundData.playButton.visible = false
        soundData.pauseButton.visible = true
        this.playingSoundData = soundData
    }

    public playAllVideos() {
        if (this.isVideoPlaying === false && this.appData.videoList && this.appData.videoList.length > 0) {
            for (let index = 0; index < this.appData.videoList.length; index++) {
                const video = this.appData.videoList[index].video;
                video.play()
            }
        }
    }
}

